import React, { FC, RefObject, useMemo } from 'react';
import classNames from 'classnames';
import nextId from 'react-id-generator';
import { useMediaDesktop } from '@app/react/common/useMedia';
import { OrderSelectBaseLayout } from '@component/OrderSelectBaseLayout';
import {
    OrderPartsImg,
    ProductThumbnail,
    OnSelectProductHandler,
} from '@app/react/uikit';
import { PartsProduct } from '@app/react/const/type';

export interface OrderTypeZeroSelectComponentProps {
    rootRef?: RefObject;
    noProduct: PartsProduct;
    yesProduct: PartsProduct | null;
    selectedProduct: PartsProduct | null;
    onSelectProduct: OnSelectProductHandler;
}

export const OrderTypeZeroSelectComponent: FC<OrderTypeZeroSelectComponentProps> = (
    props,
) => {
    const {
        rootRef, noProduct, yesProduct, selectedProduct, onSelectProduct,
    } = props;

    const isDesktop = useMediaDesktop();

    const rootClassName = {
        root: classNames('order-typezero-select'),
    };

    const htmlId = useMemo(() => nextId('order-typezero-select'), []);

    const products = (
        <ul className="product-container">
            <ProductThumbnail
                product={noProduct}
                checked={noProduct.id === selectedProduct?.id}
                groupName={htmlId}
                onClick={onSelectProduct}
            />
            {yesProduct && (
                <ProductThumbnail
                    product={yesProduct}
                    checked={yesProduct.id === selectedProduct?.id}
                    groupName={htmlId}
                    onClick={onSelectProduct}
                />
            )}
        </ul>
    );

    const body = (
        <div className="design-container">
            <div className="container-overflow" ref={rootRef}>
                <p className={classNames('section-header', { hidden: isDesktop })}>
                    ZERO流
                </p>
                <p className="order-typezero-select__description">
                    さらなる飛貫中の実現のために長年の研究により生みだされた技術です。
                    独自技術ため詳細は紹介できませんが矢飛びの向上を体感いただけます。
                    ぜひお試しください。
                </p>
                {products}
            </div>
        </div>
    );

    return (
        <OrderSelectBaseLayout
            classNames={rootClassName}
            header={isDesktop && (
                <OrderPartsImg partsName="ZERO流" onHelpClick={() => false} />
            )}
            body={body}
        />
    );
};
